import type { QueryClient } from '@tanstack/react-query';
import { redirect ,type  LoaderFunctionArgs} from 'react-router-dom';

import { getPlayerQuery } from '@/api/player/usePlayer';
import type { BanModel } from '@/models/bans';
import { banReasons } from '@/models/reasons';
import { BanService } from '@/services/ban/banService';


export const editBanAction =
  (queryClient: QueryClient) =>
  async ({ request, params }: LoaderFunctionArgs) => {
    const formData = await request.formData();
    const { banId, playerId, gameId, sandboxId } = params;
    if (!playerId || !gameId || !sandboxId) {
      return null;
    }
    const updates = Object.fromEntries(formData);
    const partialBan = updates as Partial<BanModel>;
    if (partialBan.duration && !+partialBan.duration) {
      alert('Please select a non zero duration');
      return null;
    }
    const intent = formData.get('intent');
    const features = formData.get('features') as string;

    //  revoke ban intent
    if (intent === 'revoke') {
      if (!banId) {
        throw Error('Ban ID is required');
      }
      await BanService.liftBan(banId, partialBan.liftedReason ?? '');
    } else {
      if ('reason' in updates) {
        partialBan.reason = banReasons.find(
          (reason) => reason.id === updates.reason,
        );
      }
      partialBan.features = features.split(',').map((f) => f.trim());
      if (!banId) {
        await BanService.createBan(playerId, partialBan);
      } else {
        await BanService.updateBan(banId, partialBan);
      }
    }
    await queryClient.invalidateQueries({
      queryKey: getPlayerQuery(playerId).queryKey,
    });

    return redirect(
      `/game/${gameId.toString()}/${sandboxId}/players/${playerId.toString()}/bans`,
    );
  };
